const state = {
  // Add any slide-progress specific state here if needed
}

const _getters = {
  visibleSlides: (_, __, rootState, rootGetters) => {
    if (rootGetters['featureToggles/canUseSkipSlide']) {
      const { slideAttributes } = rootState
      return (rootState.slides || []).filter((slide) => {
        return !slideAttributes?.[slide.id]?.skipSlide
      })
    }
    return rootState.slides || []
  },

  isFinalLeaderboard: (_, getters, __, rootGetters) => {
    const slidesQuiz = getters.slideQuizzes
    let isFinalLeaderboard = false
    const slides = getters.visibleSlides
    if (slides) {
      const index = slides.findIndex((item) => item.id === rootGetters.activeActivity.id)
      let indexQuiz = 0
      if (slidesQuiz.length) {
        indexQuiz = slides.findIndex(
          (item) => item.id === slidesQuiz[slidesQuiz.length - 1].id,
        )
      }
      if (index > indexQuiz) {
        isFinalLeaderboard = true
      }
    }

    return isFinalLeaderboard
  },
  slideQuizzes: (_, getters, __, rootGetters) => {
    return (getters.visibleSlides ?? []).filter((item) => {
      return rootGetters.isQuizSlide(item)
    })
  },
  totalQuizzes: (_, getters) => {
    return getters.slideQuizzes?.length ?? 0
  },
  isLastVisibleSlide: (_, getters, rootState, rootGetters) => {
    if (!rootState.presentation) return false
    const { lastSlide } = rootState.presentation
    const slide = rootGetters.activeActivity
    if (!slide) return false
    const canUseSkipSlide = rootGetters['featureToggles/canUseSkipSlide']
    if (canUseSkipSlide) {
      const { slideAttributes } = rootState
      if (!slideAttributes?.[lastSlide]?.skipSlide) {
        return slide.id === lastSlide
      }
      const visibleLastSlide = getters.visibleSlides?.[getters.visibleSlides.length - 1]
      return slide.id === visibleLastSlide?.id
    }
    return slide.id === lastSlide
  },

  latestSlideQuizIndex: (_, getters, __, rootGetters) => {
    const slide = rootGetters.activeActivity
    const { visibleSlides } = getters
    let currentSlideIndex = visibleSlides.length - 1
    while (currentSlideIndex >= 0 && visibleSlides[currentSlideIndex].id !== slide.id) currentSlideIndex--
    let lastQuizSlide
    for (let index = currentSlideIndex; index >= 0 && !lastQuizSlide; index--) {
      if (rootGetters.isQuizSlide(visibleSlides[index])) lastQuizSlide = visibleSlides[index]
    }
    return getters.slideQuizzes.findIndex((quiz) => quiz.id === lastQuizSlide?.id)
  },
}

const mutations = {
  // Add mutations if needed
}

const actions = {
  // Add actions if needed
}

export default {
  namespaced: true,
  state,
  getters: _getters,
  mutations,
  actions,
}
